import {LatLngExpression} from "leaflet";

export const DEFAULT_POSITION: LatLngExpression = [48.866667, 2.333333]; // Paris
